import { ApiType } from "@gymflow/common";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { facilityQueryKeys } from "./facilityQueryKeys";

export function useFacilityUpdatePicture({ api }: { api: ApiType }) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({
      facilityId,
      file,
    }: {
      facilityId: number;
      file: { blob: string; name: string };
    }) => {
      await api.facilityApi.updatePicture(facilityId, file);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: facilityQueryKeys.all() });
    },
  });
}
